var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginXButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.435176 0.777587C0.703905 0.509339 1.1253 0.487167 1.41909 0.711139L1.49587 0.778291L6.61875 5.90867L11.7521 0.784561C12.0452 0.49194 12.5201 0.492367 12.8127 0.785513C13.081 1.05424 13.1029 1.4757 12.879 1.76944L12.8118 1.84617L7.67846 6.97028L12.8012 12.0994C13.0938 12.3924 13.0936 12.8674 12.8005 13.16C12.5318 13.4283 12.1104 13.4504 11.8166 13.2264L11.7398 13.1593L6.61684 8.02999L1.48643 13.1512C1.19327 13.4438 0.71839 13.4434 0.425769 13.1503C0.157522 12.8815 0.13552 12.4601 0.359498 12.1663L0.426721 12.0896L5.55714 6.96838L0.434472 1.83821C0.141773 1.54513 0.14203 1.07021 0.435176 0.777587Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginXButton);
export default __webpack_public_path__ + "static/media/LoginXButton.3eeefbb916f2e16172d15b4b69e05d34.svg";
export { ForwardRef as ReactComponent };